/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Center, Container, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Field, Form, Formik } from 'formik';
import BreadcrumbComponent from '../../../components/BreadcrumbComponent/BreadcrumbComponent';
import RichTextEditorField from '../../../components/form/RichTextEditorField';
import RichTextEditorFields from '../../../components/form/RichTextEditorField/array';
import RichTextEditorViewer from '../../../components/form/RichTextEditorField/viewer';
import c from '../../../constant';
import * as Yup from 'yup';

const editing = false;
const objective = `<p><span style="font-size: 14px;">ការស្នើសុំពិនិត្យ និងសម្រេចផ្តល់ហត្ថលេខាដ៏ខ្ពង់ខ្ពស់របស់ ឯកឧត្តមអគ្គនាយក លើរបាយការណ៍វាយតម្លៃសមិទ្ធកម្មមន្ត្រី ដើម្បីបញ្ចូលមន្រ្តីកម្មសិក្សាចំនួន ១ រូប ជាមន្រ្តីលក្ខន្តិកៈរបស់អាជ្ញាធរសេវាហិរញ្ញវត្ថុមិនមែនធនាគារ។</span></p>`;
const reference = `<p><span style="font-size: 14px;">ប្រកាសលេខ ០១០ អ.ស.ហ.ប្រក ចុះថ្ងៃទី៨ ខែតុលា ឆ្នាំ២០២១ ស្តីពីលក្ខន្តិកៈនៃមន្រ្តីលក្ខន្តិកៈរបស់អាជ្ញាធរសេវាហិរញ្ញវត្ថុមិនមែនធនាគារ។</span></p>`;
const content = `
<style type="text/css">
p.p1 {margin: 0.0px 0.0px 0.0px 0.0px; text-align: center; text-indent: 16.6px; font: 7.0px 'Khmer Sangam MN'; color: #000000}
p.p2 {margin: 0.0px 0.0px 0.0px 0.0px; text-align: justify; text-indent: 30.2px; font: 11.0px 'Khmer Sangam MN'; color: #000000}
p.p3 {margin: 0.0px 0.0px 0.0px 0.0px; text-align: justify; font: 11.0px 'Khmer Sangam MN'; color: #000000}
span.s1 {letter-spacing: -0.5px}
span.s2 {font: 11.0px Helvetica; letter-spacing: -0.5px}
span.s3 {font: 11.0px Helvetica}
span.s4 {letter-spacing: 0.3px}
span.s5 {letter-spacing: -0.4px}
span.s6 {font: 11.0px Helvetica; letter-spacing: -0.4px}
span.s7 {letter-spacing: -0.2px}
span.s8 {font: 11.0px Helvetica; letter-spacing: -0.2px}
span.s9 {letter-spacing: 0.2px}
span.s10 {font: 11.0px Helvetica; letter-spacing: 0.2px}
span.Apple-tab-span {white-space:pre}
</style>
<p class="p2" style="text-align: justify;"><span style="font-family: KhmerOSSiemreap; font-size: 14px;">សេចក្ដីដូចមានចែងក្នុងកម្មវត្ថុនិងយោងខាងលើខ្ញុំសូមគោរពជម្រាបជូនឯកឧត្តមអគ្គនាយក&nbsp; មេត្តាជ្រាបដ៏ខ្ពង់ខ្ពស់ថាមន្ត្រីកម្មសិក្សាឈ្មោះឡៃចាន់ណារ៉ាបានបំពេញការងារនៅការិយាល័យបច្ចេកវិទ្យាធានារ៉ាប់រងនៃនាយកដ្ឋានស្រាវជ្រាវបណ្តុះបណ្តាលនិងសហប្រតិបត្តិការនៃនិយ័តករធានារ៉ាប់រងកម្ពុជារយៈពេល៣ខែគិតចាប់ពីខែកញ្ញាគ.ស.២០២៣។តាមរយៈការបំពេញការងារសាកល្បងរយៈពេលកន្លងមកនេះមន្ត្រីកម្មសិក្សារូបនេះបានបង្ហាញនូវកិច្ចខិតខំប្រឹងប្រែងយ៉ាងសកម្មក្នុងការបំពេញការងារនិងមានលក្ខណៈសម្បត្តិនិងគុណវុឌ្ឍិគ្រប់គ្រាន់ដើម្បីវាយតម្លៃបញ្ចូលជាមន្ត្រីលក្ខន្តិកៈរបស់អាជ្ញាធរសេវាហិរញ្ញវត្ថុមិនមែនធនាគារ (អ.ស.ហ.)។ក្នុងន័យនេះនាយកដ្ឋានជំនាញសូមគោរពស្នើសុំការពិនិត្យនិងសម្រេចផ្ដល់ហត្ថលេខាដ៏ខ្ពង់ខ្ពស់របស់ឯកឧត្ដមអគ្គនាយកលើរបាយការណ៍វាយតម្លៃសមិទ្ធកម្មមន្ត្រីដើម្បីបញ្ចូលមន្ត្រីកម្មសិក្សារូបនេះជាមន្ត្រីលក្ខន្តិកៈរបស់អ.ស.ហ. ដូចមានគោរពជូនភ្ជាប់ដោយក្ដីអនុគ្រោះបំផុត។</span></p><p class="p2"><span style="font-family: KhmerOSSiemreap; font-size: 14px;"><br></span></p>
<p class="p2" style="text-align: justify;"><span style="font-family: KhmerOSSiemreap; font-size: 14px;">សេចក្ដីដូចមានចែងក្នុងកម្មវត្ថុនិងយោងខាងលើខ្ញុំសូមគោរពជម្រាបជូនឯកឧត្តមអគ្គនាយក&nbsp; មេត្តាជ្រាបដ៏ខ្ពង់ខ្ពស់ថាមន្ត្រីកម្មសិក្សាឈ្មោះឡៃចាន់ណារ៉ាបានបំពេញការងារនៅការិយាល័យបច្ចេកវិទ្យាធានារ៉ាប់រងនៃនាយកដ្ឋានស្រាវជ្រាវបណ្តុះបណ្តាលនិងសហប្រតិបត្តិការនៃនិយ័តករធានារ៉ាប់រងកម្ពុជារយៈពេល៣ខែគិតចាប់ពីខែកញ្ញាគ.ស.២០២៣។តាមរយៈការបំពេញការងារសាកល្បងរយៈពេលកន្លងមកនេះមន្ត្រីកម្មសិក្សារូបនេះបានបង្ហាញនូវកិច្ចខិតខំប្រឹងប្រែងយ៉ាងសកម្មក្នុងការបំពេញការងារនិងមានលក្ខណៈសម្បត្តិនិងគុណវុឌ្ឍិគ្រប់គ្រាន់ដើម្បីវាយតម្លៃបញ្ចូលជាមន្ត្រីលក្ខន្តិកៈរបស់អាជ្ញាធរសេវាហិរញ្ញវត្ថុមិនមែនធនាគារ (អ.ស.ហ.)។ក្នុងន័យនេះនាយកដ្ឋានជំនាញសូមគោរពស្នើសុំការពិនិត្យនិងសម្រេចផ្ដល់ហត្ថលេខាដ៏ខ្ពង់ខ្ពស់របស់ឯកឧត្ដមអគ្គនាយកលើរបាយការណ៍វាយតម្លៃសមិទ្ធកម្មមន្ត្រីដើម្បីបញ្ចូលមន្ត្រីកម្មសិក្សារូបនេះជាមន្ត្រីលក្ខន្តិកៈរបស់អ.ស.ហ. ដូចមានគោរពជូនភ្ជាប់ដោយក្ដីអនុគ្រោះបំផុត។</span></p><p class="p2"><span style="font-family: KhmerOSSiemreap; font-size: 14px;"><br></span></p>
<p class="p1"><span style="font-family: KhmerOSSiemreap; font-size: 14px;"><strong>យោបល់នាយកដ្ឋានជំនាញ</strong></span></p>
<p class="p2" style="text-align: justify;"><span style="font-family: KhmerOSSiemreap; font-size: 14px;">សេចក្ដីដូចមានចែងក្នុងកម្មវត្ថុនិងយោងខាងលើខ្ញុំសូមគោរពជម្រាបជូនឯកឧត្តមអគ្គនាយក&nbsp; មេត្តាជ្រាបដ៏ខ្ពង់ខ្ពស់ថាមន្ត្រីកម្មសិក្សាឈ្មោះឡៃចាន់ណារ៉ាបានបំពេញការងារនៅការិយាល័យបច្ចេកវិទ្យាធានារ៉ាប់រងនៃនាយកដ្ឋានស្រាវជ្រាវបណ្តុះបណ្តាលនិងសហប្រតិបត្តិការនៃនិយ័តករធានារ៉ាប់រងកម្ពុជារយៈពេល៣ខែគិតចាប់ពីខែកញ្ញាគ.ស.២០២៣។តាមរយៈការបំពេញការងារសាកល្បងរយៈពេលកន្លងមកនេះមន្ត្រីកម្មសិក្សារូបនេះបានបង្ហាញនូវកិច្ចខិតខំប្រឹងប្រែងយ៉ាងសកម្មក្នុងការបំពេញការងារនិងមានលក្ខណៈសម្បត្តិនិងគុណវុឌ្ឍិគ្រប់គ្រាន់ដើម្បីវាយតម្លៃបញ្ចូលជាមន្ត្រីលក្ខន្តិកៈរបស់អាជ្ញាធរសេវាហិរញ្ញវត្ថុមិនមែនធនាគារ (អ.ស.ហ.)។ក្នុងន័យនេះនាយកដ្ឋានជំនាញសូមគោរពស្នើសុំការពិនិត្យនិងសម្រេចផ្ដល់ហត្ថលេខាដ៏ខ្ពង់ខ្ពស់របស់ឯកឧត្ដមអគ្គនាយកលើរបាយការណ៍វាយតម្លៃសមិទ្ធកម្មមន្ត្រីដើម្បីបញ្ចូលមន្ត្រីកម្មសិក្សារូបនេះជាមន្ត្រីលក្ខន្តិកៈរបស់អ.ស.ហ. ដូចមានគោរពជូនភ្ជាប់ដោយក្ដីអនុគ្រោះបំផុត។</span></p><p class="p2"><span style="font-family: KhmerOSSiemreap; font-size: 14px;"><br></span></p>
<p class="p2" style="text-align: justify;"><span style="font-family: KhmerOSSiemreap; font-size: 14px;">សេចក្ដីដូចមានចែងក្នុងកម្មវត្ថុនិងយោងខាងលើខ្ញុំសូមគោរពជម្រាបជូនឯកឧត្តមអគ្គនាយក&nbsp; មេត្តាជ្រាបដ៏ខ្ពង់ខ្ពស់ថាមន្ត្រីកម្មសិក្សាឈ្មោះឡៃចាន់ណារ៉ាបានបំពេញការងារនៅការិយាល័យបច្ចេកវិទ្យាធានារ៉ាប់រងនៃនាយកដ្ឋានស្រាវជ្រាវបណ្តុះបណ្តាលនិងសហប្រតិបត្តិការនៃនិយ័តករធានារ៉ាប់រងកម្ពុជារយៈពេល៣ខែគិតចាប់ពីខែកញ្ញាគ.ស.២០២៣។តាមរយៈការបំពេញការងារសាកល្បងរយៈពេលកន្លងមកនេះមន្ត្រីកម្មសិក្សារូបនេះបានបង្ហាញនូវកិច្ចខិតខំប្រឹងប្រែងយ៉ាងសកម្មក្នុងការបំពេញការងារនិងមានលក្ខណៈសម្បត្តិនិងគុណវុឌ្ឍិគ្រប់គ្រាន់ដើម្បីវាយតម្លៃបញ្ចូលជាមន្ត្រីលក្ខន្តិកៈរបស់អាជ្ញាធរសេវាហិរញ្ញវត្ថុមិនមែនធនាគារ (អ.ស.ហ.)។ក្នុងន័យនេះនាយកដ្ឋានជំនាញសូមគោរពស្នើសុំការពិនិត្យនិងសម្រេចផ្ដល់ហត្ថលេខាដ៏ខ្ពង់ខ្ពស់របស់ឯកឧត្ដមអគ្គនាយកលើរបាយការណ៍វាយតម្លៃសមិទ្ធកម្មមន្ត្រីដើម្បីបញ្ចូលមន្ត្រីកម្មសិក្សារូបនេះជាមន្ត្រីលក្ខន្តិកៈរបស់អ.ស.ហ. ដូចមានគោរពជូនភ្ជាប់ដោយក្ដីអនុគ្រោះបំផុត។</span></p><p class="p2"><span style="font-family: KhmerOSSiemreap; font-size: 14px;"><br></span></p>
<p class="p2" style="text-align: justify;"><span style="font-family: KhmerOSSiemreap; font-size: 14px;">សេចក្ដីដូចមានចែងក្នុងកម្មវត្ថុនិងយោងខាងលើខ្ញុំសូមគោរពជម្រាបជូនឯកឧត្តមអគ្គនាយក&nbsp; មេត្តាជ្រាបដ៏ខ្ពង់ខ្ពស់ថាមន្ត្រីកម្មសិក្សាឈ្មោះឡៃចាន់ណារ៉ាបានបំពេញការងារនៅការិយាល័យបច្ចេកវិទ្យាធានារ៉ាប់រងនៃនាយកដ្ឋានស្រាវជ្រាវបណ្តុះបណ្តាលនិងសហប្រតិបត្តិការនៃនិយ័តករធានារ៉ាប់រងកម្ពុជារយៈពេល៣ខែគិតចាប់ពីខែកញ្ញាគ.ស.២០២៣។តាមរយៈការបំពេញការងារសាកល្បងរយៈពេលកន្លងមកនេះមន្ត្រីកម្មសិក្សារូបនេះបានបង្ហាញនូវកិច្ចខិតខំប្រឹងប្រែងយ៉ាងសកម្មក្នុងការបំពេញការងារនិងមានលក្ខណៈសម្បត្តិនិងគុណវុឌ្ឍិគ្រប់គ្រាន់ដើម្បីវាយតម្លៃបញ្ចូលជាមន្ត្រីលក្ខន្តិកៈរបស់អាជ្ញាធរសេវាហិរញ្ញវត្ថុមិនមែនធនាគារ (អ.ស.ហ.)។ក្នុងន័យនេះនាយកដ្ឋានជំនាញសូមគោរពស្នើសុំការពិនិត្យនិងសម្រេចផ្ដល់ហត្ថលេខាដ៏ខ្ពង់ខ្ពស់របស់ឯកឧត្ដមអគ្គនាយកលើរបាយការណ៍វាយតម្លៃសមិទ្ធកម្មមន្ត្រីដើម្បីបញ្ចូលមន្ត្រីកម្មសិក្សារូបនេះជាមន្ត្រីលក្ខន្តិកៈរបស់អ.ស.ហ. ដូចមានគោរពជូនភ្ជាប់ដោយក្ដីអនុគ្រោះបំផុត។</span></p><p class="p2"><span style="font-family: KhmerOSSiemreap; font-size: 14px;"><br></span></p>
<p class="p2"><span style="font-family: KhmerOSSiemreap; font-size: 14px;">អាស្រ័យដូចបានគោរពជម្រាបជូនខាងលើសូមឯកឧត្តមអគ្គនាយកមេត្តាពិនិត្យនិងសម្រេចដ៏ខ្ពង់ខ្ពស់។</span></p>
<p class="p3"><span style="font-family: KhmerOSSiemreap; font-size: 14px;">សូមឯកឧត្តមអគ្គនាយកមេត្តាទទួលនូវគារវកិច្ចដ៏ខ្ពង់ខ្ពស់ពីខ្ញុំ។</span></p>`;

const validationSchema = Yup.object().shape({
	editing: Yup.boolean(),
	objective: Yup.string().nullable(),
	reference: Yup.string().nullable(),
	references: Yup.array().of(Yup.string().nullable()),
	content: Yup.string().nullable(),
});

function NoteOfPresentation() {
	const { t } = useTranslation();

	return (
		<>
			<Container maxW="container.xl" mt="16px" mb="16px">
				<BreadcrumbComponent
					list={[
						{
							name: 'Settings',
							path: '/settings',
						},
						{
							name: 'Note of Presentation',
							path: '#',
						},
					]}
				/>
				<Center mt="5">
					<Box
						w="100%"
						bg="white"
						borderRadius={c.borderRadius}
						border="1px solid #dbdbdb"
						boxShadow="0 1px 2px rgba(var(--black, #000), 0.1)"
						pb="32px"
					>
						<Flex
							justifyContent="space-between"
							alignItems="center"
							bg="#FAFAFA"
							p="16px"
							pt="8px"
							pb="8px"
							mb="16px"
							borderBottom="1px solid #dbdbdb"
						>
							<Flex justifyContent="center" alignItems="center">
								<Text fontSize="x-large" fontWeight="bold" mr="4">
									{t('Note of Presentation')}
								</Text>
							</Flex>
						</Flex>
						<Box ml={4} mr={4}>
							<Formik
								initialValues={{ editing, objective, reference, content }}
								validationSchema={validationSchema}
								onSubmit={(values) => console.log(values)}
							>
								{({ values, ...props }) => {
									return (
										<Form>
											<Box mt={8}>
												<Field hidden name="editing" />
												<Flex mb={4}>
													<Box w="80px">
														<Text textAlign="left" fontFamily="KhmerOSMuolLight">
															កម្មវត្ថុ៖
														</Text>
													</Box>
													<Box width="100%">
														{values?.editing ? (
															<>
																<RichTextEditorField name="objective" minHeight={36} />
															</>
														) : (
															<>
																{values?.objective ? (
																	<>
																		<RichTextEditorViewer value={values?.objective} />
																	</>
																) : (
																	<>
																		<Box height="36px" backgroundColor="gray.50" borderWidth={1} borderColor="gray.200" />
																	</>
																)}
															</>
														)}
													</Box>
												</Flex>
												<Flex mb={4}>
													<Box w="80px">
														<Text textAlign="left" fontFamily="KhmerOSMuolLight">
															យោង៖
														</Text>
													</Box>
													<Box width="100%">
														{values?.editing ? (
															<>
																<RichTextEditorField name="reference" minHeight={72} />
															</>
														) : (
															<>
																{values?.reference ? (
																	<>
																		<RichTextEditorViewer value={values?.reference} />
																	</>
																) : (
																	<>
																		<Box height="72px" backgroundColor="gray.50" borderWidth={1} borderColor="gray.200" />
																	</>
																)}
															</>
														)}
													</Box>
												</Flex>
												<Flex mb={4}>
													<Box w="80px">
														<Text textAlign="left" fontFamily="KhmerOSMuolLight">
															យោង៖
														</Text>
													</Box>
													<Box width="100%">
														{values?.editing ? (
															<>
																<RichTextEditorFields name="references" minHeight={72} />
															</>
														) : (
															<>
																{values?.reference ? (
																	<>
																		<RichTextEditorViewer value={values?.reference} />
																	</>
																) : (
																	<>
																		<Box height="72px" backgroundColor="gray.50" borderWidth={1} borderColor="gray.200" />
																	</>
																)}
															</>
														)}
													</Box>
												</Flex>
												<Box mb={4}>
													{values?.editing ? (
														<>
															<RichTextEditorField name="content" minHeight={216} />
														</>
													) : (
														<>
															{values?.content ? (
																<>
																	<RichTextEditorViewer value={values?.content} />
																</>
															) : (
																<>
																	<Box
																		width="100%"
																		height="216px"
																		backgroundColor="gray.50"
																		borderWidth={1}
																		borderColor="gray.200"
																	/>
																</>
															)}
														</>
													)}
												</Box>
												<Flex justifyContent="flex-end" alignItems="center">
													<Button
														size="md"
														pl={8}
														pr={8}
														mr={2}
														colorScheme={values?.editing ? 'green' : 'blue'}
														onMouseDown={() => props?.setFieldValue('editing', values?.editing ? false : true)}
													>
														{values?.editing ? t('Save') : t('Edit')}
													</Button>
													<Button type="submit" size="md" pl={8} pr={8} mr={0}>
														{t('Submit')}
													</Button>
												</Flex>
											</Box>
										</Form>
									);
								}}
							</Formik>
						</Box>
					</Box>
				</Center>
			</Container>
		</>
	);
}

export default NoteOfPresentation;
